import * as _ from 'lodash';

const _error = {
    errorTitle: undefined,
    errorMessage: undefined,
    errorServerMsg: undefined,
    errorCode: '',
    httpStatusCode: '',
};

export function errorTemplate() {
    return {
        ..._.cloneDeep(_error)
    }
}

export function getError(payload, defaultMessage) {
    return {
        errorTitle: getErrorTitle(payload),
        errorMessage: getErrorMessage(payload, defaultMessage),
        errorCode: getErrorCode(payload),
        httpStatusCode: getHttpStatusCode(payload) || 0,
    }
}


export function getErrorTitle(error) {
    return _.get(error, 'response.data.errorTitle', '');
}

export function getErrorMessage(error, defaultMessage) {
    let message = '';
    if (_.isEmpty(error)) {
        message = _.isEmpty(defaultMessage) ? 'Unknown error' : defaultMessage;
    }
    else if (_.isEmpty(error.response)) {
        if (_.isEmpty(error.message)) {
            message = 'Unknown error';
        }
        else {
            message = _.trimEnd(error.message, '.') + '. ';
        }
    }
    else {
        if (_.get(error, 'response.data.status') !== undefined && error.response.data.status === 401) {
            return 'Unauthorized: Access is denied. ';
        }
        const errorMessage = _.isEmpty(_.get(error, 'response.data.errorMessage', '')) ? '' : error.response.data.errorMessage;
        const rootCause = _.isEmpty(_.get(error, 'response.data.rootCauseMessage', '')) ? '' : error.response.data.rootCauseMessage;

        if (!_.isEmpty(errorMessage)) {
            message = _.trimEnd(errorMessage,'.') + '. ';
        }
        else if (!_.isEmpty(rootCause)) {
            message = _.trimEnd(rootCause,'.') + '. ';
        }
        else {
            message = _.isEmpty(defaultMessage) ? 'Unknown error' : defaultMessage;
        }
    }
    return message;
}

export function getErrorCode(error) {
    if (_.isEmpty(error) || _.isEmpty(error.response) || _.isEmpty(error.response.data) ) {
        return 500;
    }
    return _.isUndefined(error.response.data.errorCode) ? 0 : error.response.data.errorCode;
}

export function getHttpStatusCode(error) {
    if (_.isEmpty(error) || _.isEmpty(error.response)) {
        return 500;
    }
    else if (!_.isUndefined(error.response.status)) {
        return error.response.status;
    }
    else if (!_.isEmpty(_.get(error,'response.data', '')) && !_.isUndefined(error.response.data.httpStatus)) {
        return  error.response.data.httpStatus;
    }

    return 500;
}